import React, { createContext, useState, useEffect } from 'react';
import { ClipLoader } from 'react-spinners';
import { getMe } from '../api/authApi';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const data = await getMe(token);
          setUser({ userData: data.userData, token: data.token });
        } catch (error) {
          console.error('Ошибка получения данных пользователя:', error);
          setUser(null);
        }
      }
      setLoading(false);
    };

    fetchUserData();
  }, []);

  if (loading) {
    return (
      <div className="loading">
        <ClipLoader size={50} color={'#123abc'} loading={true} />
      </div>
    );
  }

  return <AuthContext.Provider value={{ user, setUser }}>{children}</AuthContext.Provider>;
};
